<template>
  <TableGradient
      icon-name="cogs"
      :title="$t('protocolsettings.listagem.titulo_pagina')"
      :text-empty="$t('protocolsettings.listagem.table.empty')"
      route-new="vns.protocol_settings.create"
      :text-new="$t('protocolsettings.listagem.novo')"
      :fields="fields"
      :fields-filter="filter"
      :items="protocols"
      :paginator="paginator"
      :loading="isLoading"
      @list="evt => $store.dispatch('protocolSettings/listAll', evt)"
      table-data>
    <template v-slot:cell(id)="linha">
      <router-link :id="`link-edit-${linha.index}`"
                   :to="{ name: 'vns.protocol_settings.edit', params: { id: linha.item.id }}"
                   class="font-weight-bold">
        {{ $t('protocolsettings.listagem.table.editar') }}
      </router-link>
    </template>
    <template v-slot:cell(status)="linha">
      <span
          :class="{'rounded-pill p-1 ':true, 'badge badge-success':linha.item.status, 'badge badge-danger': !linha.item.status}">
          <i :class="linha.item.status ? 'fas fa-check' : 'fas fa-ban'"/>
      </span>
    </template>
  </TableGradient>
</template>

<script>
import TableGradient from "@/templates/TableGradient";
import {mapActions, mapGetters} from 'vuex'

export default {
  name: "Index",
  components: {TableGradient},
  computed: {
    ...mapGetters({
      protocols: 'protocolSettings/all',
      paginator: 'protocolSettings/pagination',
      store_isLoading: 'protocolSettings/isLoading'
    }),
    isLoading() {
      return !(this.mounted && this.store_isLoading === false)
    }
  },
  data() {
    return {
      mounted: false,
      fields: [
        {key: 'name', label: this.$t('protocolsettings.listagem.table.nome'), sortable: true},
        {key: 'request_method', label: this.$t('protocolsettings.listagem.table.metodo'), sortable: true},
        {key: 'order_verifier_url', label: this.$t('protocolsettings.listagem.table.ordem_url'), sortable: true},
        {key: 'support_observation_verifier_url', label: this.$t('protocolsettings.listagem.table.resultado_url'), sortable: true},
        {key: 'support_observation_endpoint', label: this.$t('protocolsettings.listagem.table.busca_resultado_url'), sortable: true},
        {key: 'id', label: this.$t('protocolsettings.listagem.table.editar')}
      ],
      filter: [
        {key: 'name', label: this.$t('protocolsettings.listagem.table.nome')},
      ]
    }
  },
  methods: {
    ...mapActions([
      'protocolSettings/listAll'
    ])
  },
  mounted() {
    this['protocolSettings/listAll'](this.paginator)
    this.mounted = true
  }
}
</script>

<style lang="scss" scoped>
</style>
